import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { ConfirmModalComponent, ConfirmModalTone } from "../components/confirm-modal/confirm-modal.component";

export interface ConfirmModalOptions {
  title: string;
  message: string;
  detail?: string;
  confirmLabel: string;
  cancelLabel: string;
  tone?: ConfirmModalTone;
}

@Injectable()
export class ConfirmModalService {
  constructor(private modalService: NgbModal) {}

  confirm(options: ConfirmModalOptions): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      centered: true,
      backdrop: "static",
      windowClass: "customer-confirm-window",
      modalDialogClass: "customer-confirm-dialog",
      animation: false
    });

    modalRef.componentInstance.title = options.title;
    modalRef.componentInstance.message = options.message;
    modalRef.componentInstance.detail = options.detail || "";
    modalRef.componentInstance.confirmLabel = options.confirmLabel;
    modalRef.componentInstance.cancelLabel = options.cancelLabel;
    modalRef.componentInstance.tone = options.tone || "accent";

    return modalRef.result.then(
      () => true,
      () => false
    );
  }
}
